// -------------- Hook to call the api endpoint for the AI assistant ---------------
// ----------------------------------------------------------------------------------
// import functions and service
import { useState, useEffect, useCallback } from 'react';
import { researchQuery, getResearchUsage } from '../services/api';

// custom hook to handle research queries and usage tracking
export const useResearch = () => {
  const [usage, setUsage] = useState({ requests_today: 0, daily_limit: 250, remaining: 250 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getResearchUsage().then(setUsage).catch(console.error);
  }, []); // fetch initial usage data on mount

  // function to send a research query and update usage state
  const sendQuery = useCallback(async ({ question, timeframe, model }) => {
    setLoading(true);
    setError(null);

    try {
      // send the research query to the backend API
      const data = await researchQuery({ question, timeframe, model });

      // update usage state with the latest usage data from the response
      setUsage({
        requests_today: data.requests_today,
        daily_limit: data.daily_limit,
        remaining: data.remaining,
      });
      return data;

    } catch (err) { // handle errors and update error state
      const msg = err.message || 'Request failed. Check backend connection.';
      setError(msg);
      throw err;

    } finally { // ensure loading state is reset after the request completes
      setLoading(false);
    }
  }, []);

  return { usage, loading, error, sendQuery }; // return the usage and states to frontend
};
